import React from 'react';
import styles from './EmptyState.module.css';
import { NotFound, SimpleCustomImage } from './components';
import { Contents } from './components/Default/Contents';
import { InfoAction } from './components/Default/InfoAction';
import { EmptyStateProps, EmptyStateType } from './type';
import { ErrorRetrieveData } from './components/ErrorRetrieveData/ErrorRetrieveData';

/**
 * All of this component's props is optionals.
 * If you implement a prop, you should be aware with the mandatory vs optional sub props
 *
 * @param productTranslation - use this param without adding title param, it will generate the default wording with your product in it
 * @param title - replace default title
 * @param description - replace default description
 * @param type - Default for first time user. Not found for filter interactions
 * @param contents - wrap a js object as EmptyStateContentType and add it into the element
 * @param buttons - wrap a js object as EmptyStateActionButtons to add buttons below main info
 */
function EmptyState({
  contents = [],
  type = EmptyStateType.DEFAULT,
  sourcePage,
  ...info
}: EmptyStateProps) {
  const generateContent = (type: EmptyStateType) => {
    switch (type) {
      case EmptyStateType.DEFAULT:
        return (
          <>
            <InfoAction {...info} />
            {contents.map((contentProps, idx) => (
              <Contents
                key={`EmptyState_Content_${contentProps.imageName + idx}`}
                source_page={sourcePage}
                {...contentProps}
              />
            ))}
          </>
        );
      case EmptyStateType.SIMPLE_CUSTOM_IMAGE:
        return <SimpleCustomImage {...info} />;
      case EmptyStateType.ERROR_RETRIEVE_DATA:
        return <ErrorRetrieveData />;  
      default:
        return <NotFound {...info} />;
    }
  };

  return <div className={styles.container}>{generateContent(type)}</div>;
}

EmptyState.type = EmptyStateType;

export default EmptyState;
